export enum WorkOrderChangeMenuActionTypes {
    openMoveVolumesBetweenSeasonsUer = 'openMoveVolumesBetweenSeasonsUer',

    addRatio = 'addRatio',
    addMtr = 'addMtr',

    editUer = 'editUer',
    editRatio = 'editRatio',
    editNote = 'editNote',
    editMtr = 'editMtr',
    matchMtr = 'matchMtr',
    editOther = 'editOther',
    editOtherDistribution = 'editOtherDistribution',

    singleDelete = 'singleDelete',
    exclude = 'exclude',
}

export enum WorkOrderOtherOpEnum {
    edit = 'edit',
    view = 'view',
}
